import {
	AreaChart,
	BarChart,
	DonutChart,
} from "@mantine/charts";
import { Checkbox, Grid, Group, Paper, Stack, Title } from "@mantine/core";
import React, { useMemo } from 'react';
import {
	ResponsiveContainer
} from "recharts";
import { useLanguage } from '../../contexts/language.context';

export const CallsChart = (
	{ callVolume = [], status = [], campaigns = [] }:
		{ callVolume: any[], status: any[], campaigns: any[] }
) => {
	const { str } = useLanguage();
	const totalOutcome = useMemo(() => status.reduce((pv, it) => (pv + it.value), 0), [status]);

	return (
		<Grid>
			<Grid.Col span={{ md: 12 }}>
				<Paper p="md">
					<Stack gap={20}>
						<Title order={3}>{str("REPORTS.PICKUP_VOLUME_OVER_TIME")}</Title>
						<ResponsiveContainer width="100%" height={300}>
							<AreaChart
								data={callVolume}
								h={300}
								dataKey="time"
								type="stacked"
								series={[
									{ name: 'answered', label: str("REPORTS.ANSWERED"), color: 'blue.6' },
									{ name: 'calls', label: str("REPORTS.CALLS"), color: 'blue.3' },
								]}
							/>
							{/* <AreaChart data={callVolume}>
								<CartesianGrid strokeDasharray="3 3" stroke="gray" />
								<XAxis
									dataKey="time"

									fontSize={12}
								/>
								<YAxis

									fontSize={12}
								/>
								<Tooltip
									contentStyle={{
										border: "1px solid gray",
									}}
								/>
								<Area
									type="monotone"
									dataKey="calls"
									color="blue.8"
									fillOpacity={0.2}
									strokeWidth={2}
								/>
								<Area
									type="monotone"
									dataKey="answered"
									color="blue.3"
									fillOpacity={0.1}
									strokeWidth={2}
								/>
							</AreaChart> */}
						</ResponsiveContainer>
					</Stack>
				</Paper >
			</Grid.Col>
			<Grid.Col span={{ md: 6 }}>
				<Paper p="md">
					<Stack gap={20}>
						<Title order={3}>{str("REPORTS.CALL_STATUS")}</Title>
						<ResponsiveContainer width="100%" height={280}>
							<DonutChart
								paddingAngle={5}
								withLabels
								data={status}
								thickness={30}
								size={200}
							/>
						</ResponsiveContainer>
						<Group>
							{status.map((item) => (
								<div key={item.name} className="flex items-center space-x-2">
									<Checkbox
										color={item.color}
										checked={true}
										label={`${item.name}: ${(100 * (item.value / totalOutcome)).toFixed(0)}%`}
									/>
								</div>
							))}
						</Group>
					</Stack>
				</Paper>
			</Grid.Col>
			<Grid.Col span={{ md: 6 }}>
				<Paper p="md">
					<Stack gap={20}>
						<Title order={3}>{str("REPORTS.CAMPAIGN_PERFORMANCE")}</Title>
						<ResponsiveContainer width="100%" height={350}>
							<BarChart
								data={campaigns}
								dataKey="campaign"
								type="stacked"
								series={[
									{ name: "Outcome", label: str("REPORTS.OUTCOME"), color: "green" },
									{ name: "Answered", label: str("REPORTS.ANSWERED"), color: "blue" },
									{ name: "No Answer", label: str("REPORTS.NO_ANSWER"), color: "yellow" },
								]}
							/>
						</ResponsiveContainer>
					</Stack>
				</Paper>
			</Grid.Col>
		</Grid>
	);
};